import React from "react";
import cx from "classnames";
import "./CircleButton.scss";
import PropTypes from 'prop-types';
export const CircleButton = (props) => {
  const classNames = cx(
    "circle-button",
  props.classes,
  {
    "circle-button--loading": props.isLoading,
    "circle-button--disabled": props.isDisabled,
    "circle-button--selected": props.isSelected,
  },
  );
  function handleClick(e) {
    e.preventDefault();
    const { isDisabled, isLoading, clickHandler } = props;
    if(isLoading || isDisabled) return;
    clickHandler(e);
  };
  return (
    <button title={props.title} className={classNames} onClick={handleClick}>
      {props.render()}
    </button>
  );
};

CircleButton.propTypes = {
  render: PropTypes.func.isRequired,
  clickHandler: PropTypes.func.isRequired,
  classes: PropTypes.array,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
};
CircleButton.defaultProps = {
  isLoading: false,
  isDisabled: false,
  isSelected: false,
  title: "",
};
